import { useEffect, useRef, useState } from 'react'

const ResponsiveTitle = ({
  left,
  center,
  size = 'big',
  right,
  className = '',
}) => {
  const containerRef = useRef(null)
  const [isWrapped, setIsWrapped] = useState(false)
  const fontSize = {
    big: 'text-headingMobile md:text-headingDesktop',
    medium: 'text-headingMobile md:text-displayDesktop',
    small: 'text-headingMobile md:text-subheadingDesktop',
  }

  useEffect(() => {
    const checkWrap = () => {
      const container = containerRef.current
      if (!container) return

      const children = Array.from(container.children).filter(
        (el) => window.getComputedStyle(el).display !== 'none',
      )

      if (children.length < 2) {
        setIsWrapped(false)
        return
      }

      const firstTop = children[0].offsetTop
      const firstHeight = children[0].offsetHeight

      const isRowWrap = children.some((child) => {
        const diff = Math.abs(child.offsetTop - firstTop)
        return diff >= firstHeight
      })

      setIsWrapped(isRowWrap)
    }

    const observer = new ResizeObserver(checkWrap)
    if (containerRef.current) observer.observe(containerRef.current)

    window.addEventListener('resize', checkWrap)
    checkWrap()

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', checkWrap)
    }
  }, [])

  return (
    <div
      ref={containerRef}
      className={`relative w-full flex flex-wrap flex-row items-center gap-x-[20px] uppercase text-olive font-ttDrugsTrial ${
        isWrapped ? 'justify-center' : 'justify-center md:justify-between'
      } ${className}`}
    >
      <span className={`${fontSize[size]} text-center`}>
        {left} {isWrapped && center ? center : ''}
      </span>
      <span
        className={`${!isWrapped && center ? '' : 'hidden'} ${fontSize[size]}`}
      >
        {center}
      </span>
      <span className={`${fontSize[size]}`}>{right}</span>
    </div>
  )
}

export default ResponsiveTitle
